<template>
  <div class="page-home">
    <!-- banner -->
    <section class="swiper-container banner-swiper-container">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(img, idx) in bannerImgUrls"
          :key="idx"
        >
          <img
            :src="img"
            style="width:100%;"
          >
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </section>
    <!-- 心晴门诊 -->
    <section class="section clinic-section fix-banner-margin">
      <div class="section-mask"></div>
      <div class="section-inner">
        <div class="tc">
          <h4 class="section-title">心晴门诊</h4>
          <p class="section-title-words">XinQing Clinic</p>
          <p class="section-title-line"></p>
        </div>
        <div class="section-content">
          <p>心晴门诊是一个专业的精神心理专科门诊，致力于提供便捷高效的预约服务和专业贴心的诊疗服务。我们努力打造和实践MDT（即多学科协作）的诊疗模式，我们努力做到以患者为中心，针对具体情况整合医疗资源，依托多学科团队为患者制定最佳的诊疗方案，精神心理方面的问题，主要以精神医学与心理学联合诊疗为主。心晴门诊，始终以专业温暖的服务守护您心晴！</p>
        </div>
      </div>
    </section>
    <!-- 多学科协作诊疗模式（MDT） -->
    <section class="section mdt-section">
      <div class="section-mask"></div>
      <div class="section-inner">
        <h4 class="section-title">多学科协作诊疗模式（MDT）</h4>
        <p class="section-title-words">Multi-Disciplinary Team</p>
        <p class="section-title-line"></p>
        <div class="section-content">
          <p>精神心理方面的问题，主要是以精神医学和心理学联合诊疗为主。</p>
          <p>MDT（Multi-Disciplinary Team）即多学科协作诊疗模式，该模式以患者为中心，针对特定疾病整合医疗资源，依托多学科团队，为患者确定最佳的诊疗方案。</p>
        </div>
        <div class="section-content mt-def">
          <p class="text-primary">为什么要选择MDT？</p>
          <p>三甲医院的心理门诊大多侧重药物治疗，而市面上一般的心理咨询机构侧重一般性心理咨询，但患者情况更多时候是复杂多变的，心晴门诊打造的MDT（精神医学与心理学联合诊疗）模式可以给予患者整体的诊疗服务。</p>
        </div>
      </div>
    </section>
    <!-- 资深专家团队 -->
    <section class="section doctors-section">
      <div class="section-inner">
        <h4 class="section-title">资深专家团队</h4>
        <p class="section-title-words">Multi-Disciplinary Team</p>
        <p class="section-title-line"></p>
        <div class="section-content mb-def">
          <p>心晴门诊的精神科医生均是来自三甲医院、有丰富临床诊疗经验的优秀专家；我们的资深心理师均有扎实的医学心理学背景以及专业的受训经历，可以提供精神分析、家庭治疗、沙盘游戏治疗、绘画治疗等专业服务。优秀的精神心理专家联手，致力为来访提供专业、优质、安全、细致、充满人文关怀的精神心理诊疗。</p>
        </div>
        <div class="swiper-container doctor-swiper-container mt-def">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="doctor of doctorList"
              :key="doctor.doctor_id"
              @click="viewExpretDetail(doctor.id)"
            >
              <img
                :src="doctor.img"
                :alt="doctor.name"
                style="width: 180px;height:240px;"
              >
              <div class="tc">
                <p>{{ doctor.name }}</p>
                <p class="text-dark">{{ doctor.title }}</p>
                <p class="text-dark">{{ doctor.edu_background }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 广州医保定点医疗机构 -->
    <section class="section insurance-section">
      <div class="section-mask" style="background: rgba(255, 255, 255, 0.8)"></div>
      <div class="section-inner clearfix">
        <article class="fl">
          <h4 class="section-title">广州医保定点医疗机构</h4>
          <p class="section-title-line"></p>
          <div class="section-content">
            <p>支持广州医保使用，门慢可用。</p>
          </div>
        </article>
        <article class="mt-def fr" style="width: 75%;">
          <div class="tr">
            <h4 class="section-title">完善的药事服务</h4>
            <p class="section-title-line"></p>
          </div>
          <div class="section-content">
            <p>收录优质药品1500余种，专科药品齐全，可按处方配药；</p>
            <p>心晴门诊药房配备已有备案审核资质的药师对医生开出的处方进行审核。</p>
            <p>心晴药房严格按照医药品类进行采购，同时具备《药品经营质量管理规范认证证书》、《互联网药品交易服务资格证书》等证书。</p>
          </div>
        </article>
      </div>
    </section>
    <!-- 预约咨询 -->
    <section class="section appointment-section">
      <div class="section-mask"></div>
      <div class="section-inner">
        <h4 class="section-title">预约咨询</h4>
        <p class="section-title-line"></p>
        <div
          class="clearfix"
          style="margin: 10px 80px 20px"
        >
          <article class="fl tc">
            <div class="section-content">
              <img
                src="~@/assets/images/appointment_code.png"
                alt="门诊助理预约二维码"
                style="width: 150px"
              >
              <p class="text-green">打开微信【扫一扫】</p>
              <p>扫码添加助理微信预约咨询</p>
              <a
                class="text-primary"
                href="#/appointment/question"
                target="_block"
              ><i class="iconfont icon-tips_fill"></i> 常见问题解答</a>
            </div>
          </article>
          <article class="fr tc">
            <div class="section-content">
              <p class="strong">预约咨询</p>
              <p>扫码添加助理微信</p>
              <p class="iconfont icon-triangle_down_fill text-primary fs-20"></p>
              <p>向助理描述简况</p>
              <p class="iconfont icon-triangle_down_fill text-primary fs-20"></p>
              <p>确认预约意愿并支付</p>
              <p class="iconfont icon-triangle_down_fill text-primary fs-20"></p>
              <p>预约成功</p>
            </div>
          </article>
        </div>
        <p class="pb-def">注：如无法亲临门诊面诊，可通过APP进行网络或电话问诊，<a href="https://android.myapp.com/myapp/detail.htm?apkName=com.doctor.sun&ADTAG=mobile" target="_block" class="text-link">点击此处下载应用</a>。</p>
      </div>
    </section>
    <!-- 心晴动态 -->
    <section class="section news-section">
      <div class="section-inner clearfix">
        <article
          class="fl tl"
          style="width: 48%"
        >
          <div class="clearfix">
            <h4 class="section-title">
              <a href="javascript:void(0)" @click="goNewsPage('LECTURE')">心晴动态</a>
            </h4>
            <p class="section-title-line"></p>
          </div>
          <div class="section-content">
            <div
              v-for="news of dynamicNewsList"
              :key="news.id"
              class="news-item"
              @click="viewNewsDetail(news)"
            >
              <img
                class="news-image"
                :src="news.img"
                :alt="news.title"
              >
              <div class="news-content">
                <p class="strong mb-def-half">{{ news.title }}</p>
                <p class="text-overflow-2">{{ news.desc }}</p>
                <p class="text-gray mt-def-small">{{ news.create_time | toDate('YYYY/MM/DD') }}</p>
              </div>
            </div>
            <div class="tr text-gray">
              <a href="https://mp.weixin.qq.com/mp/homepage?__biz=MzU3OTIyNTMzNA==&hid=4&sn=cd797de945ef5eefded41006f7f34339&scene=18" target="_block">查看更多</a>
            </div>
          </div>
        </article>
        <article
          class="fr tl"
          style="width: 48%"
        >
          <h4 class="section-title">
            <a href="javascript:void(0)" @click="goNewsPage('EXPERT')">心晴科普</a>
          </h4>
          <p class="section-title-line"></p>
          <div class="section-content">
            <div
              v-for="news of guideNewsList"
              :key="news.id"
              class="news-item"
              @click="viewNewsDetail(news)"
            >
              <img
                class="news-image"
                :src="news.img"
                :alt="news.title"
              >
              <div class="news-content">
                <p class="strong mb-def-half">{{ news.title }}</p>
                <p class="text-overflow-2">{{ news.desc }}</p>
                <p class="text-gray mt-def-small">{{ news.create_time | toDate('YYYY/MM/DD') }}</p>
              </div>
            </div>
            <div class="tr text-gray">
              <a href="https://mp.weixin.qq.com/mp/homepage?__biz=MzU3OTIyNTMzNA==&hid=3&sn=2a1c5eef24a739a37d964b5cf249e7fa&scene=18" target="_block">查看更多</a>
            </div>
          </div>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
import { getDoctorList } from 'api/doctor'
import { getNewsList } from 'api/news'
import { viewNewsDetail } from 'utils/util'

export default {
  name: 'page-home',
  data() {
    return {
      bannerImgUrls: [
        require('@/assets/images/home_banner_1.png'),
        require('@/assets/images/home_banner_2.png'),
        require('@/assets/images/home_banner_3.png'),
        require('@/assets/images/home_banner_4.png'),
        require('@/assets/images/home_banner_5.png'),
        require('@/assets/images/home_banner_6.png')
      ],
      doctorList: [],
      dynamicNewsList: [],
      guideNewsList: [],
      newsPageQuery: {
        page: 1,
        size: 3
      }
    }
  },
  methods: {
    getDoctorList() {
      getDoctorList().then(list => {
        this.doctorList = list
        // TODO: 延迟实例化 swiper 避免渲染样式错误
        setTimeout(() => {
          /* global Swiper */
          /* eslint-disable no-new */
          new Swiper('.doctor-swiper-container', {
            autoplay: true,
            delay: 5000,
            loop: true,
            slidesPerView: 4
          })
        }, 10)
      })
    },
    getDynamicNewsList() {
      getNewsList({ ...this.newsPageQuery, type: 'LECTURE' }).then(
        ({ list }) => {
          this.dynamicNewsList = list
        }
      )
    },
    getGuideNewsList() {
      getNewsList({ ...this.newsPageQuery, type: 'EXPERT' }).then(
        ({ list }) => {
          this.guideNewsList = list
        }
      )
    },
    swiperInit() {
      /* global Swiper */
      /* eslint-disable no-new */
      new Swiper('.banner-swiper-container', {
        autoplay: true,
        delay: 5000,
        loop: true,
        paginationClickable: true,
        pagination: {
          el: '.swiper-pagination'
        }
      })
    },
    viewExpretDetail(id) {
      this.$router.push({ name: 'doctor-detail', query: { id } })
    },
    viewNewsDetail(news) {
      viewNewsDetail(news)
    },
    goNewsPage(activeMenu) {
      this.$router.push({ name: 'news', query: { activeMenu: activeMenu } })
    }
  },
  mounted() {
    this.swiperInit()
    this.getDoctorList()
    this.getDynamicNewsList()
    this.getGuideNewsList()
  }
}
</script>

<style lang='less' scoped>
@import '~variables.less';
// @section-height: 420px;
// @section-height: auto;
@min-section-height: 340px;

.section {
  position: relative;
  // height: @section-height;
  min-height: @min-section-height;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;

  .section-mask {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.88);
  }

  .section-inner {
    position: relative;
    z-index: 2;
    padding: @gutter * 1.5 0;
    margin: 0 auto;
    text-align: center;
  }

  &.clinic-section {
    background-image: url('~@/assets/images/home_clinic_bg.png');
    .section-inner {
      width: 60%;
      text-align: left;
    }
    &.fix-banner-margin {
      z-index: 2;
      margin-top: -10px;
    }
  }

  &.mdt-section {
    background-image: url('~@/assets/images/home_mdt_bg.png');
    .section-inner {
      width: 60%;
      text-align: left;
    }
  }

  &.doctors-section {
    height: auto;
    .section-inner {
      text-align: center;
    }
    .section-content {
      width: 60%;
      margin-left: auto;
      margin-right: auto;
    }
    .doctor-swiper-container {
      width: 80%;
      margin-left: auto;
      margin-right: auto;
    }
    .swiper-slide:hover {
      cursor: pointer;
    }
  }

  &.insurance-section {
    background-image: url('~@/assets/images/home_insurance_bg.png');
    .section-inner {
      width: 60%;
      text-align: left;
    }
  }

  &.appointment-section {
    height: auto;
    background-image: url('~@/assets/images/home_appointment_bg.png');
    .section-inner {
      width: 60%;
    }
  }

  &.news-section {
    height: auto;
    .section-inner {
      width: 80%;
    }
    .section-content {
      line-height: 1.4;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue